module.exports = __webpack_public_path__ + "img/DSC_0079.ad994c0a.jpg";